<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <g transform="translate(-1300 -196)">
            <circle class="a" cx="19" cy="19" r="19" transform="translate(1300 196)" fill="#383935"/>
            <g transform="translate(1311.366 206.785)">
                <path class="b" d="M14.352,14.23H.333a.255.255,0,0,1-.253-.218c-.013-.089-.31-2.181,1.043-3.146a4.888,4.888,0,0,1,1.836-.674A3.682,3.682,0,0,0,5.4,8.935c.008-.008.264-.4-.545-1.394C3.552,5.95,3.849,3.432,3.973,2.7A3.37,3.37,0,0,1,7.343,0a3.372,3.372,0,0,1,3.37,2.7c.121.733.421,3.249-.882,4.842-.812.989-.553,1.386-.55,1.388a3.687,3.687,0,0,0,2.443,1.264,4.871,4.871,0,0,1,1.836.674c1.353.962,1.057,3.057,1.043,3.146A.253.253,0,0,1,14.352,14.23ZM.565,13.715H14.118a2.823,2.823,0,0,0-.855-2.432,4.471,4.471,0,0,0-1.65-.593,4.2,4.2,0,0,1-2.739-1.45c-.046-.051-.542-.682.558-2.027,1.165-1.424.887-3.753.774-4.432A2.859,2.859,0,0,0,7.34.51,2.859,2.859,0,0,0,4.474,2.78c-.113.679-.391,3.006.774,4.432,1.1,1.345.6,1.976.545,2.044A4.181,4.181,0,0,1,3.067,10.69a4.423,4.423,0,0,0-1.65.593A2.83,2.83,0,0,0,.565,13.715Z" transform="translate(0)" fill="#a5d867" stroke="#a5d867" stroke-width="0.5px"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'ProfileIcon'
}
</script>

<style scoped>
    svg {
        width:38px;
        height: 38px;
    }
</style>